/* Veviane LP system — shared behaviours */
(function () {
  'use strict';

  var DE_DAYS = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];
  var DE_MONTHS = ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sept.', 'Okt.', 'Nov.', 'Dez.'];
  function pad(n) { return String(n).padStart(2, '0'); }
  function endOfMonth(d) { return new Date(d.getFullYear(), d.getMonth() + 1, 0, 23, 59, 59); }
  function fmtDate(d) { return pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.'; }
  function fmtDay(d) { return DE_DAYS[d.getDay()] + ' ' + d.getDate() + '. ' + DE_MONTHS[d.getMonth()]; }

  /* ---------- reveal on scroll (with safety net) ---------- */
  var revealEls = document.querySelectorAll('[data-mb-reveal]');
  if ('IntersectionObserver' in window) {
    var revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mb-revealed'); revealIO.unobserve(e.target); }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px 12% 0px' });
    revealEls.forEach(function (el) { revealIO.observe(el); });
  }
  setTimeout(function () { revealEls.forEach(function (el) { el.classList.add('mb-revealed'); }); }, 2000);

  /* ---------- count-up numbers ---------- */
  function countUp(el) {
    var target = parseFloat(el.dataset.mbCount || '0');
    var suffix = el.dataset.mbSuffix || '';
    var prefix = el.dataset.mbPrefix || '';
    var sep = el.dataset.mbThousands === '1';
    var dur = parseInt(el.dataset.mbDuration || '1400', 10);
    var start = performance.now();
    function fmt(v) {
      var s = String(Math.round(v));
      return sep ? s.replace(/\B(?=(\d{3})+(?!\d))/g, '.') : s;
    }
    function tick(now) {
      var p = Math.min((now - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = prefix + fmt(target * eased) + suffix;
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }
  var countEls = document.querySelectorAll('[data-mb-count]');
  if ('IntersectionObserver' in window) {
    var countIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { countUp(e.target); countIO.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    countEls.forEach(function (el) { countIO.observe(el); });
  } else {
    countEls.forEach(countUp);
  }

  /* ---------- countdown (month end = real monthly draw deadline, or fixed date) ---------- */
  document.querySelectorAll('[data-mb-countdown]').forEach(function (root) {
    var mode = root.dataset.mbCountdownMode || 'month_end';
    var fixed = root.dataset.mbCountdownDate || '';
    function target() {
      if (mode === 'fixed' && fixed) {
        var t = new Date(fixed + 'T23:59:59');
        if (!isNaN(t)) return t;
      }
      return endOfMonth(new Date());
    }
    var dEl = root.querySelector('[data-mb-cd-d]');
    var hEl = root.querySelector('[data-mb-cd-h]');
    var mEl = root.querySelector('[data-mb-cd-m]');
    var sEl = root.querySelector('[data-mb-cd-s]');
    var dateEl = root.querySelector('[data-mb-cd-date]');
    function render() {
      var end = target();
      var diff = Math.max(0, end - Date.now());
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (dEl) dEl.textContent = pad(d);
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
      if (dateEl) dateEl.textContent = fmtDate(end);
    }
    render();
    setInterval(render, 1000);
  });

  /* ---------- monthly draw progress bar ---------- */
  document.querySelectorAll('[data-mb-draw]').forEach(function (root) {
    var now = new Date();
    var end = endOfMonth(now);
    var daysInMonth = end.getDate();
    var daysLeft = Math.max(0, Math.ceil((end - now) / 86400000));
    var pct = Math.min(100, Math.max(4, Math.round(((now.getDate() - 1) + now.getHours() / 24) / daysInMonth * 100)));
    var dayWord = daysLeft === 1 ? '1 Tag' : daysLeft + ' Tage';
    if (daysLeft === 0) dayWord = 'heute um Mitternacht';
    var labelEl = root.querySelector('[data-mb-draw-label]');
    var subEl = root.querySelector('[data-mb-draw-sub]');
    var fill = root.querySelector('[data-mb-draw-fill]');
    if (labelEl) labelEl.textContent = (root.dataset.label || '').replace('[date]', fmtDate(end));
    if (subEl) subEl.textContent = (root.dataset.sub || '').replace('[days]', dayWord);
    if (fill) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { fill.style.width = pct + '%'; io.unobserve(e.target); }
          });
        }, { threshold: 0.3 });
        io.observe(root);
      } else {
        fill.style.width = pct + '%';
      }
    }
  });

  /* ---------- delivery estimate (business days, German dates) ---------- */
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(y, month - 1, day);
  }
  var holidayCache = {};
  function holidays(y) {
    if (holidayCache[y]) return holidayCache[y];
    var e = easter(y);
    function off(n) { var d = new Date(e.getTime()); d.setDate(d.getDate() + n); return (d.getMonth() + 1) + '-' + d.getDate(); }
    var list = ['1-1', '5-1', '10-3', '12-24', '12-25', '12-26', '12-31', off(-2), off(1), off(39), off(50)];
    holidayCache[y] = list;
    return list;
  }
  function isBusinessDay(d) {
    var wd = d.getDay();
    if (wd === 0 || wd === 6) return false;
    return holidays(d.getFullYear()).indexOf((d.getMonth() + 1) + '-' + d.getDate()) === -1;
  }
  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      if (isBusinessDay(d)) added++;
    }
    return d;
  }
  document.querySelectorAll('[data-mb-delivery]').forEach(function (el) {
    var min = parseInt(el.dataset.min || '3', 10);
    var max = parseInt(el.dataset.max || '5', 10);
    var cutoff = parseInt(el.dataset.cutoff || '14', 10);
    var tpl = el.dataset.template || '';
    var textEl = el.querySelector('[data-mb-delivery-text]');
    if (!textEl || !tpl || isNaN(min) || isNaN(max)) return;
    var now = new Date();
    var shipsToday = isBusinessDay(now) && now.getHours() < cutoff;
    var start = shipsToday ? now : addBusinessDays(now, 1);
    var from = addBusinessDays(start, min);
    var to = addBusinessDays(start, max);
    var range = '<b>' + fmtDay(from) + ' – ' + fmtDay(to) + '</b>';
    textEl.innerHTML = tpl.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace('[range]', range);
  });

  /* ---------- marquee: duplicate content for seamless loop ---------- */
  document.querySelectorAll('.mb-marquee__track').forEach(function (track) {
    if (track.dataset.mbDup) return;
    track.dataset.mbDup = '1';
    var base = track.innerHTML;
    var baseCount = track.children.length;
    var unitW = track.scrollWidth || 1;
    var need = (track.parentElement ? track.parentElement.clientWidth : window.innerWidth) || window.innerWidth;
    var reps = 1, half = base;
    while (unitW * reps < need && reps < 12) { half += base; reps++; }
    track.innerHTML = half + half;
    if (reps > 1) {
      var dur = parseFloat(getComputedStyle(track).animationDuration) || 0;
      if (dur) track.style.animationDuration = (dur * reps) + 's';
    }
    Array.prototype.forEach.call(track.children, function (it, i) {
      if (i >= baseCount) it.setAttribute('aria-hidden', 'true');
    });
  });

  /* ---------- generic slider ---------- */
  document.querySelectorAll('[data-mb-slider]').forEach(function (root) {
    var track = root.querySelector('.mb-slider');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var dotsWrap = root.querySelector('.mb-slider-dots');
    var prev = root.querySelector('[data-mb-prev]');
    var next = root.querySelector('[data-mb-next]');
    var dots = [];
    function perView() {
      var w = track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
      var sw = slides[0] ? slides[0].offsetWidth + gap : w;
      return Math.max(1, Math.round(w / sw));
    }
    function pageIndex() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    function sync() {
      var idx = Math.min(pageIndex(), Math.max(0, dots.length - 1));
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); d.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    }
    function buildDots() {
      if (!dotsWrap) { sync(); return; }
      var pages = Math.max(1, Math.ceil(slides.length / perView()));
      dotsWrap.innerHTML = '';
      dots = [];
      if (pages > 1) {
        for (var i = 0; i < pages; i++) {
          (function (i) {
            var b = document.createElement('button');
            b.type = 'button';
            b.setAttribute('aria-label', 'Seite ' + (i + 1));
            b.addEventListener('click', function () { track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); });
            dotsWrap.appendChild(b);
            dots.push(b);
          })(i);
        }
      }
      sync();
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true });
    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(buildDots, 150); });
    buildDots();
  });

  /* ---------- video cards ---------- */
  document.querySelectorAll('[data-mb-video]').forEach(function (card) {
    var video = card.querySelector('video');
    var overlay = card.querySelector('[data-mb-video-play]');
    if (!video || !overlay) return;
    overlay.addEventListener('click', function () {
      document.querySelectorAll('[data-mb-video] video').forEach(function (v) {
        if (v !== video) { v.pause(); v.closest('[data-mb-video]').classList.remove('is-playing'); }
      });
      if (video.paused) { video.muted = false; video.play(); card.classList.add('is-playing'); }
      else { video.pause(); card.classList.remove('is-playing'); }
    });
    video.addEventListener('ended', function () { card.classList.remove('is-playing'); });
  });

  /* ---------- popup ---------- */
  document.querySelectorAll('[data-mb-popup]').forEach(function (popup) {
    var key = 'mb_popup_' + (popup.dataset.mbPopupKey || 'v1');
    var delay = parseInt(popup.dataset.mbPopupDelay || '12', 10) * 1000;
    var seen = null;
    try { seen = sessionStorage.getItem(key); } catch (e) {}
    var justSubmitted = !!popup.querySelector('.mb-popup__ok');
    if (seen && !justSubmitted) return;
    var form = popup.querySelector('form');
    if (form) form.addEventListener('submit', function () { try { sessionStorage.setItem(key, '1'); } catch (e) {} });
    var timer = setTimeout(open, justSubmitted ? 0 : delay);
    function open() {
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      var first = popup.querySelector('button, a');
      if (first) first.focus({ preventScroll: true });
    }
    function close() {
      clearTimeout(timer);
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      try { sessionStorage.setItem(key, '1'); } catch (e) {}
    }
    popup.querySelectorAll('[data-mb-popup-close]').forEach(function (b) { b.addEventListener('click', close); });
    popup.addEventListener('click', function (e) { if (e.target === popup) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && popup.classList.contains('is-open')) close(); });
  });

  /* ---------- sticky ATC: visible once the main buy button has scrolled away ---------- */
  var sticky = document.querySelector('[data-mb-sticky-atc]');
  if (sticky) {
    var watch = document.querySelector('[data-mb-atc-form]') || document.querySelector('[data-mb-buybox]');
    var btn = sticky.querySelector('button');
    function setVisible(v) {
      sticky.classList.toggle('is-visible', v);
      sticky.setAttribute('aria-hidden', v ? 'false' : 'true');
      if (btn) btn.tabIndex = v ? 0 : -1;
      document.body.classList.toggle('mb-has-sticky', v);
    }
    if (watch && 'IntersectionObserver' in window) {
      var ctaVisible = true, bottomVisible = false;
      var bottom = document.querySelector('.mb-price');
      var update = function () { setVisible(!ctaVisible && !bottomVisible); };
      var sio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.target === watch) ctaVisible = e.isIntersecting;
          else bottomVisible = e.isIntersecting;
        });
        update();
      }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });
      sio.observe(watch);
      if (bottom) sio.observe(bottom);
    }
  }
})();
